import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MARKETPLACE_CURRENCY_DENOMINATION } from "../../../utils/marketplaceConstants";
import FormGroupTile from "../../../components/core/basic/FormGroupTile";
import { useQueryClient } from "@tanstack/react-query";
import api from "../../../utils/api";
import { Checkbox } from "../../../components/fields/base/Checkbox";
import { Button } from "../../../components/core/basic/Button";
import { css } from "../../../../styled-system/css";
import { Modal } from "../../../components/core/basic/Modal";

const CogsEditModal = ({
  showProductEditModal,
  setShowProductEditModal,
  productEditModalDetails,
  setProductEditModalDetails,
  marketPlace,
}) => {
  const { t } = useTranslation(["merchandising", "common"]);
  const queryClient = useQueryClient();

  const onUpdateProductDetails = async () => {
    const product = productEditModalDetails;
    await api.patch(`/merchandise/gvproducts/${product.id}/`, {
      landed_cost: parseFloat(product.landed_cost),
      shipping_cost: parseFloat(product.shipping_cost),
      vine_program_enrolled: product.vine_program_enrolled,
    });

    queryClient.invalidateQueries();

    setShowProductEditModal(false);
  };

  return (
    <Modal
      isOpen={showProductEditModal}
      onOpenChange={(isOpen) => setShowProductEditModal(isOpen)}
      title={t(($) => $.merchandising["Edit Product Cost Details"])}
      css={{ width: "50vw", padding: "xlarge" }}
    >
      <Row className="py-5">
        <Col xs={12} md={4} className="px-4">
          <FormGroupTile
            label={t(($) => $.merchandising["Landed Cost"])}
            type="formcontrol"
            decimalInput={true}
            stateName={"landed_cost"}
            handleChildFormElement={(key, value) => {
              setProductEditModalDetails({
                ...productEditModalDetails,
                landed_cost: value,
              });
            }}
            formControlClass="no-arrows text-center"
            defaultValue={productEditModalDetails.landed_cost}
            placeholder={`${MARKETPLACE_CURRENCY_DENOMINATION[marketPlace.marketPlace]}`}
          />
        </Col>
        <Col xs={12} md={4} className="px-4">
          <FormGroupTile
            label={t(($) => $.merchandising["Shipping Cost"])}
            type="formcontrol"
            decimalInput={true}
            stateName={"shipping_cost"}
            handleChildFormElement={(key, value) => {
              setProductEditModalDetails({
                ...productEditModalDetails,
                shipping_cost: value,
              });
            }}
            disabled={productEditModalDetails?.fulfillment_channel === "AFN"}
            formControlClass="no-arrows text-center"
            defaultValue={productEditModalDetails.shipping_cost}
            placeholder={
              productEditModalDetails?.fulfillment_channel === "AFN" ?
                t(($) => $.merchandising["Fulfilled by Amazon"])
              : `${MARKETPLACE_CURRENCY_DENOMINATION[marketPlace.marketPlace]}`
            }
          />
        </Col>
        <Col xs={12} md={4} className="d-flex align-items-end pb-2 px-4">
          <Checkbox
            label={t(($) => $.merchandising["Enrolled In Vine Program"])}
            value={productEditModalDetails.vine_program_enrolled}
            onChange={() => {
              setProductEditModalDetails({
                ...productEditModalDetails,
                vine_program_enrolled: !productEditModalDetails.vine_program_enrolled,
              });
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
          className="mt-5"
        >
          <Button className={css({ marginRight: "2rem" })} onPress={() => setShowProductEditModal(false)}>
            {t(($) => $.common.actions["Cancel"])}
          </Button>
          <Button
            onPress={async () => {
              onUpdateProductDetails();
            }}
          >
            {t(($) => $.merchandising["Change"])}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default CogsEditModal;
